import CarouselItem, { ICarouselItem } from './CarouselItem';

export type { ICarouselItem };
export default CarouselItem;
